import axios from 'axios';
import { Loading, Message } from 'element-ui'
const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    // baseURL: 'http://192.168.1.112:8600',
    timeout: 5000
});
var loadinginstace
service.interceptors.request.use(
    config => {
        var access_token=''
        if(JSON.parse(localStorage.getItem("token"))){
            access_token=JSON.parse(localStorage.getItem("token")).access_token
        }
        config.headers={
            'content-type':'application/json; charset=utf-8',
            'Authorization':'bearer'+access_token
        }
        loadinginstace = Loading.service({ fullscreen: true })
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        loadinginstace.close();
        if (response.status === 200) {
            return response.data;
        } else if(response.data.error == 'invalid_token'){
            console.log('1111111')
            this.$message.error('请重新登录');
        } else {
            Promise.reject();
        }
    },
    error => {
        loadinginstace.close();
        console.log(error);
        return Promise.reject();
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js